<div 
    class="fixed w-full inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30 gap-4"
    (click)="$event.preventDefault(); handleCloseStudentInfo();"
>
    <div class="w-full max-w-screen-sm flex flex-row gap-1 justify-center" (click)="$event.stopPropagation()">
        <div class="w-full flex flex-col min-w-full bg-white p-10 rounded-md text-center shadow-lg gap-2">
            <div class="w-full flex flex-col gap-2 items-center justify-center pb-4 border-b border-orange-200">
                <div class="w-full flex gap-2 items-center justify-between">                        
                    <h2 class="w-full oswald-font text-xl font-medium text-start text-nside-orange-400">
                        Student Information
                    </h2>
                    <button
                        class="p-1 rounded-full hover:bg-gray-100"
                        (click)="$event.preventDefault(); handleCloseStudentInfo();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
            </div>
            <div *ngIf="studentData" class="w-full flex flex-col items-center gap-2 pb-4 border-b border-orange-200">
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>SSID:</p>
                    </div>
                    <div class="w-full flex flex-col items-center">
                        <p class="w-full">{{ this.studentData.student_identifier }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>First Name:</p>
                    </div>
                    <div class="w-full flex flex-col items-center">
                        <p class="w-full">{{ this.studentData.first_name }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>Last Name:</p>
                    </div>
                    <div class="w-full flex flex-col items-center">
                        <p class="w-full">{{ this.studentData.last_name }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>Date of Birth:</p>
                    </div>
                    <div class="w-full flex items-center">
                        <p class="w-full">{{ student_birthday_to_display }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>Grade:</p>
                    </div>
                    <div class="w-full flex flex-col items-center">
                        <p class="w-full">{{ this.studentData.grade }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>Gender:</p>
                    </div>
                    <div class="w-full flex items-center gap-2">
                        <p class="w-full">{{ this.studentData.identified_gender }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>Physical Description:</p>
                    </div>
                    <div class="w-full flex items-center gap-2">
                        <p class="w-full">{{ this.studentData.physical_description }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>Does the student have an IEP?</p>
                    </div>
                    <div class="w-full flex items-center gap-2">
                        <p class="w-full">{{ showYesNo(this.studentData.has_iep) }}</p>
                    </div>                      
                </div>
                <div *ngIf="studentData.has_iep === 1" class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>IEP Contacts:</p>
                    </div>
                    <div class="w-full flex flex-col items-center">
                        <p class="w-full">{{ this.studentData.iep_contact }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>Does the student have an IHP?</p>
                    </div>
                    <div class="w-full flex items-center gap-2">                        
                        <p class="w-full">{{ showYesNo(studentData.has_ihp) }}</p>
                    </div>
                </div>
                <div class="w-full flex items-start text-start">
                    <div class="w-full flex items-center">
                        <p>Does the student have a 504?</p>
                    </div>
                    <div class="w-full flex items-center gap-2">
                        <p class="w-full">{{ showYesNo(studentData.has_504) }}</p>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-row gap-2 items-center justify-end">
                <button 
                    (click)="$event.preventDefault(); handleCloseStudentInfo();"
                    class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>